import React from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCalendar } from '../../hooks/useCalendar';

export function UpcomingEventsCard() {
  const { events } = useCalendar();

  // Get today's events
  const todayEvents = events.filter(event => {
    const today = new Date();
    const eventDate = new Date(event.startTime);
    return (
      eventDate.getDate() === today.getDate() &&
      eventDate.getMonth() === today.getMonth() &&
      eventDate.getFullYear() === today.getFullYear()
    );
  });

  return (
    <div className="upcoming-events-card rounded-xl p-3 shadow-lg" style={{ backgroundColor: 'var(--accent-color)' }}>
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-white" />
          <span className="text-sm text-white">Upcoming</span>
        </div>
        <Link 
          to="/calendar"
          className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
        >
          <ArrowRight className="w-4 h-4 text-white" />
        </Link>
      </div>
      
      <h3 className="text-lg font-medium text-white mb-0.5">Your Calendar</h3>
      <div className="flex items-baseline gap-2 mb-2"> 
        <h2 className="text-xl text-white">{todayEvents.length}</h2>
        <p className="text-white text-sm">events today</p>
      </div>

      {todayEvents.length > 0 && (
        <div className="mt-4 space-y-2">
          {todayEvents.slice(0, 2).map(event => (
            <div 
              key={event.id}
              className="flex items-center justify-between bg-white/10 rounded-xl p-2"
            >
              <div>
                <p className="text-sm font-medium text-white">{event.title}</p>
                <p className="text-xs text-white">
                  {new Date(event.startTime).toLocaleTimeString([], { 
                    hour: '2-digit', 
                    minute: '2-digit' 
                  })}
                </p>
              </div>
              {event.location && (
                <span className="text-xs text-white">{event.location}</span>
              )}
            </div>
          ))}
          {todayEvents.length > 2 && (
            <p className="text-sm text-white text-center">
              +{todayEvents.length - 2} more events
            </p>
          )}
        </div>
      )}
    </div>
  );
}